function validateForms(): void {
  const forms = document.querySelectorAll<HTMLFormElement>('.form form');
  
  // When any form on the page, disable smooth scrolling to allow browser validation messages to work
  // This is a workaround for Chromium bug: https://issues.chromium.org/issues/40196176
  if (forms.length > 0) {
    document.documentElement.style.scrollBehavior = 'auto';
  }
}

document.addEventListener('DOMContentLoaded', () => {
  validateForms();
});
